const readData = (file, prop) => {
    return new Promise((resolve, reject) => {
        try {
            const reader = new FileReader();
            reader[prop](file.raw || file);
            reader.onload = () => {
                resolve(reader.result);
            };
        } catch (err) {
            reject(err);
        }
    });
}

export const readAsArrayBuffer = file => readData(file, 'readAsArrayBuffer');
export const readAsDataUrl = file => readData(file, 'readAsDataURL');
export const readAsText = file => readData(file, 'readAsText');